import { useEffect } from 'react';
import { useNotification } from './use-notification';

/**
 * Shows "errorMessage" as an error notification whenever it changes to a message
 */
const useErrorNotification = (errorMessage: string | undefined): void => {
  const notification = useNotification();

  useEffect(() => {
    if (errorMessage) {
      notification.error({ message: ' ', description: errorMessage });
    }
  }, [errorMessage]);
};

export default useErrorNotification;
